// src/pages/xray/XrayLobby/TabsManager.js
import React from 'react';

const TabsManager = ({ selectedTab, setSelectedTab }) => {
  const tabLabels = [
    'Physical Ports',
    "VLAN's",
    'Dropped Packets',
    'WAN FAILOVER',
    'Routing',
    'Table ARP',
    'DHCP',
    'Protocol SIP',
    'Traffic PASSTHROUGH',
    'Syslog EDGEVIEW',
    'ERRORS',
    'User Commands',
    'VOS Image Version',
  ];

  return (
    <div className="tabs mt-6 flex border-b">
      {tabLabels.map((label, index) => (
        <label
          key={index}
          className={`cursor-pointer px-4 py-2 border-t border-r border-l bg-red-300 ml-1 rounded-t-md ${
            selectedTab === `tabs-level${index + 1}`
              ? 'border-b-0 font-bold'
              : 'border-red-300 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
          }`}
        >
          <input
            type="radio"
            className="hidden"
            name="tabs-group"
            checked={selectedTab === `tabs-level${index + 1}`}
            onChange={() => setSelectedTab(`tabs-level${index + 1}`)}
          />
          {label}
        </label>
      ))}
    </div>
  );
};

export default TabsManager;
